const ACCOUNT_URL = process.env.API_URL + '/account';

const getAuthorities = (context) => {
  return context.$http.get(ACCOUNT_URL);
};

export default {
  getAuthorities
};



// WEBPACK FOOTER //
// ./src/api/account/accountHttp.js